import EnumDataSource from "utils/enum-data-source.util";

export const REFUND_REASON_RETURN = 1;
export const REFUND_LOAN_RETURN = 2;
export const REFUND_OVERPAYMENT = 3;
// 4 is the backend's EXCHANGE (RefundReasonChoices, suno-backend billing/models/refund.py) — never
// offered here. It was never a real, reachable option in this dropdown (SN-19478: "Insurance
// Reimbursement" wrongly occupied 4 instead of 5, and Exchange was never selectable at all), so
// there is no user-facing behavior to preserve by adding it now. Existing rows saved with reason=4
// are a data-correction problem (see SN-19478), not a frontend one.
export const REFUND_INSURANCE_REIMBURSEMENT = 5;

// Mirrors the backend's RefundReasonChoices verbatim, minus EXCHANGE (see note above) — this
// drifted from it (Insurance Reimbursement was coded 4, colliding with the backend's own
// Exchange=4), so a refund saved as "Insurance Reimbursement" here was silently stored and read
// back by the backend as "Exchange".
export const refundReasonTypes = {
  [REFUND_REASON_RETURN]: "Return",
  [REFUND_LOAN_RETURN]: "Loan Return",
  [REFUND_OVERPAYMENT]: "Overpayment",
  [REFUND_INSURANCE_REIMBURSEMENT]: "Insurance Reimbursement"
};

export const REFUND_REASON_TYPES = new EnumDataSource(refundReasonTypes);
